/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import styled from "styled-components";
import Button from "../Button/index";

const BankDetailsSchema = Yup.object().shape({
  branchName: Yup.string().required("Branch is required"),
  ifscCode: Yup.string().required("IFSC Code is required"),
  accountNumber: Yup.number().required("Account Number is required"),
  defaultForCa: Yup.boolean().required("You must accept defaultForCa"),
});

const ModalWrapper = styled.div`
  // padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-self: stretch;
`;

const ModalFieldWrapper = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: ${(props) => props.customGap || "10px"};
  align-self: stretch;
`;

const ModalInputField = styled(Field)`
  border-radius: 3px;
  border: 0.5px solid #484848;
  padding: 10px;
  flex: 1;
`;
const Text = styled.p`
  color: #484848;
  font-size: 16px;
  font-weight: 400;
  line-height: 125%;
  margin: 0 0;
`;
const ErrorMessageContainer = styled.div`
  display: flex;
  align-items: center;
  color: red;
  font-size: 14px;
  padding-left: 24px;
`;

function BankModal({ isOpen, onClose, onSubmit, initialValues }) {
  const handleCancel = (event) => {
    event.preventDefault();
    onClose();
  };
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Edit Bank Details</DialogTitle>
      <Formik
        initialValues={initialValues}
        validationSchema={BankDetailsSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <Form>
            <DialogContent>
              <ModalWrapper>
                <ModalFieldWrapper customGap="80px">
                  <Text>Branch</Text>
                  <ModalInputField
                    type="text"
                    name="branchName"
                    placeholder="Branch"
                  />
                </ModalFieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.branchName ? (
                    <div>{formik.errors.branchName}</div>
                  ) : null}
                </ErrorMessageContainer>
                <ModalFieldWrapper customGap="60px">
                  <Text>IFSC Code</Text>
                  <ModalInputField
                    type="text"
                    name="ifscCode"
                    placeholder="IFSC Code"
                  />
                </ModalFieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.ifscCode ? (
                    <div>{formik.errors.ifscCode}</div>
                  ) : null}
                </ErrorMessageContainer>
                <ModalFieldWrapper>
                  <Text>Account Number</Text>
                  <ModalInputField
                    type="text"
                    name="accountNumber"
                    placeholder="Account Number"
                  />
                </ModalFieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.accountNumber ? (
                    <div>{formik.errors.accountNumber}</div>
                  ) : null}
                </ErrorMessageContainer>
                <ModalFieldWrapper>
                  <Text>Default for Contribution Admin</Text>
                  <div>
                    <label>
                      <Field
                        type="radio"
                        name="defaultForCa"
                        value="true"
                        checked={formik.values.defaultForCa === true}
                        onChange={() =>
                          formik.setFieldValue("defaultForCa", true)
                        }
                      />
                      Yes
                    </label>
                    <label>
                      <Field
                        type="radio"
                        name="defaultForCa"
                        value="false"
                        checked={formik.values.defaultForCa === false}
                        onChange={() =>
                          formik.setFieldValue("defaultForCa", false)
                        }
                      />
                      No
                    </label>
                  </div>
                </ModalFieldWrapper>
                <ErrorMessageContainer>
                  {formik.submitCount > 0 && formik.errors.defaultForCa ? (
                    <div>{formik.errors.defaultForCa}</div>
                  ) : null}
                </ErrorMessageContainer>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "24px",
                    width: "100%",
                  }}
                >
                  <div style={{ flex: 1 }} />
                  <Button
                    cancel
                    type="button"
                    onClick={(event) => handleCancel(event)}
                  >
                    Cancel
                  </Button>
                  <Button type="submit" onClick={formik.handleSubmit}>
                    Save
                  </Button>
                </div>
              </ModalWrapper>
            </DialogContent>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
}

export default BankModal;
